import React from 'react';
import { Award, Heart, Users, Sparkles } from 'lucide-react';
import { shopInfo } from '../data/mock';

const About = () => {
  const highlights = [
    {
      icon: Award,
      title: "20+ Years",
      description: "Of trusted service in Kashmir"
    },
    {
      icon: Heart,
      title: "Quality First",
      description: "Premium fabrics and materials"
    },
    {
      icon: Users,
      title: "Expert Team",
      description: "Knowledgeable and friendly staff"
    },
    {
      icon: Sparkles,
      title: "Unique Selection",
      description: "Exclusive designer collections"
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Title */}
        <div className="text-center mb-16">
          <h2 className="section-title mb-4">Our Heritage</h2>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-400 to-rose-400 mx-auto"></div>
        </div>

        {/* Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          {/* Text Content */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-gray-900 leading-tight">
              Weaving Trust & Elegance Since Two Decades
            </h3>
            <p className="text-lg text-gray-700 leading-relaxed">
              Located in the heart of Srinagar at Hyderpora Chowk, <span className="font-semibold text-amber-700">Global Boutique</span> has been the premier destination for premium fabrics and traditional Kashmiri wear for over 20 years.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              Our commitment to quality, authenticity, and customer satisfaction has made us a trusted name among families across Kashmir. From exquisite silks to handcrafted embroidered designs, we bring you the finest collection curated with care and expertise.
            </p>
            <p className="text-lg text-gray-700 leading-relaxed">
              At Global Boutique, we don't just sell fabrics—we help you create memories and celebrate traditions with elegance.
            </p>
          </div>

          {/* Image Grid */}
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/xok7io0q_cx.jpeg"
                alt="Shop Interior"
                className="w-full h-64 object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/a9mwnmxg_fef.jpeg"
                alt="Fabric Design"
                className="w-full h-48 object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              />
            </div>
            <div className="space-y-4 pt-8">
              <img 
                src="https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/f1anlczk_efef.jpeg"
                alt="Fabric Pattern"
                className="w-full h-48 object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              />
              <img 
                src="https://customer-assets.emergentagent.com/job_a7763a7b-9f7d-4150-a151-fed4805480f4/artifacts/ky3g7ua9_asas.jpeg"
                alt="Shop Collection"
                className="w-full h-64 object-cover rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300"
              />
            </div>
          </div>
        </div>

        {/* Highlights */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {highlights.map((item, index) => {
            const Icon = item.icon;
            return (
              <div 
                key={index}
                className="text-center p-6 rounded-xl bg-gradient-to-br from-amber-50 to-rose-50 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1"
              >
                <div className="inline-flex items-center justify-center w-16 h-16 mb-4 rounded-full bg-white shadow-md">
                  <Icon className="w-8 h-8 text-amber-600" />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-2">{item.title}</h4>
                <p className="text-gray-600">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default About;
